import React, { useEffect, useState } from "react";
import { Button, Container } from "@mui/material";
import { useJwtStorage, useLocalStorage } from "../../hooks/useLocalStorage";
import { useParams } from "react-router-dom";
import Checkbox from "@mui/material/Checkbox";

import { BrowserView } from "react-device-detect";

import Alert from "@mui/material/Alert";
import Box from "@mui/material/Box";

import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";

import DrawerAppBar from "../../components/DrawerAppBar";
import Title from "../../components/Title";
import ProgressBar from "../../components/ProgressBar";
import SubTitle from "../../components/SubTitle";

import clone from "lodash-es/clone";
import { showOKCancelDialog, showToast } from "../../components/ATPDialogs";

import { getSchoolStudents } from "../../services/UserService";

import {
  getSchoolEvent,
  getEventSignupMembers,
  updateEventStatus,
  removeEventAttendee,
  addStudentsToEvent
} from "../../services/EventService";

import { hasError, getError } from "../../services/ServiceHelper";
import "../../ResponsiveTable.css";
import EventDetails from "../../components/faculty/EventDetails";
import SelectStudentsDialog from "../../components/faculty/SelectStudentsDialog";

const EventTakeAttendance = () => {
  const [_school] = useLocalStorage("Auth", "school", null);
  const { eventEid } = useParams();

  const [_jwt] = useJwtStorage();

  const [_event, setEvent] = useState({ event: {}, members: [] });
  const [_showProgress, setShowProgress] = useState(false);
  const [_members, setMembers] = useState([]);

  const [_dialogStudentsOpen, setDialogStudentsOpen] = React.useState(false);
  const [_students, setStudents] = useState([]);

  useEffect(() => {
    initEvent();
    initSignupMembers();
    initStudents();
  }, []);

  const initStudents = () => {
    getSchoolStudents(_school, _jwt)
      .then((results) => {
        if (hasError(results) === true) {
          showToast("E", "Unable to get Students: ", getError(results));
          return;
        }

        const labeledStudents = [];
        for (const student of results.data) {
          labeledStudents.push({
            label: `${student.last_name}, ${student.first_name} (${student.grade})`,
            value: student.eid,
          });
        }

        setStudents(labeledStudents);
      })
      .catch((error) => {
        console.log("ERROR:");
        console.log(error);
      })
      .finally(() => {});
  };

  const initEvent = () => {
    setShowProgress(true);
    getSchoolEvent(_school, _jwt, eventEid)
      .then((results) => {
        if (hasError(results) === true) {
          showToast("E", "Unable to get Event: ", getError(results));
          return;
        }
        setEvent(results.data);
      })
      .catch((error) => {
        console.log("ERROR:");
        console.log(error);
      })
      .finally(() => setShowProgress(false));
  };

  const initSignupMembers = () => {
    setShowProgress(true);
    getEventSignupMembers(_school, _jwt, eventEid)
      .then((results) => {
        if (hasError(results) === true) {
          showToast(
            "E",
            "Unable to get Signup Members: ",
            getError(results)
          );
          return;
        }

        for (let member of results.data) {
          member.changed = false;
        }
        setMembers(results.data);
      })
      .catch((error) => {
        console.log("ERROR:");
        console.log(error);
      })
      .finally(() => setShowProgress(false));
  };
  //

  const handleChangeLeaveAttendModify = (event, userEid) => {
    const checked = event.target.checked;

    // clone and find
    const members = clone(_members);

    for (const member of members) {
      if (member.eid === userEid) {
        member.leaveAttendStatus = checked === true ? 100 : 0;
        member.changed = true;
        break;
      }
    }
    setMembers(members);
  };

  const handleChangeReturnAttendModify = (event, userEid) => {
    const checked = event.target.checked;

    // clone and find
    const members = clone(_members);

    for (const member of members) {
      if (member.eid === userEid) {
        member.returnAttendStatus = checked === true ? 100 : 0;
        member.changed = true;
        break;
      }
    }
    setMembers(members);
  };

  const handleChangePermissionSlipModify = (event, userEid) => {
    const checked = event.target.checked;

    // clone and find
    const members = clone(_members);

    for (const member of members) {
      if (member.eid === userEid) {
        member.permissionSlipStatus = checked === true ? 100 : 0;
        member.changed = true;
        break;
      }
    }
    setMembers(members);
  };

  const handleClickSave = () => {
    const attendees = [];

    for (const member of _members) {
      if (member.changed === true) {
        // do delta on server side
        attendees.push({
          eid: member.eid,
          leaveAttendStatus: member.leaveAttendStatus,
          returnAttendStatus: member.returnAttendStatus,
          permissionSlipStatus: member.permissionSlipStatus,
        });
      }
    }

    updateEventStatus(_school, _jwt, eventEid, attendees)
      .then((results) => {
        if (hasError(results) === true) {
          showToast(
            "E",
            "Unable to Update Event Attendance: ",
            getError(results)
          );
          return;
        }
        initSignupMembers();
        showToast("S", "Event Attendance Updated");
      })
      .catch((error) => {
        console.log("ERROR:");
        console.log(error);
      });
  };

  const removeAttendee = (student) => {
    showOKCancelDialog(
      "Remove Event Attendee?",
      `Click OK to remove ${student.first_name} ${student.last_name} from event.`,
      () => {
        doRemoveAttendee(student);
      }
    );
  };

  const doRemoveAttendee = (student) => {
    removeEventAttendee(_school, _jwt, eventEid, student.eid)
      .then((results) => {
        if (hasError(results) === true) {
          showToast(
            "E",
            "Unable to Remove Event Attendee: ",
            getError(results)
          );
          return;
        }

        // find entry and remove
        const index = _members.indexOf(student);
        if (index !== -1) {
          _members.splice(index, 1);
        }
        const members = clone(_members);
        setMembers(members);

        showToast("S", "Event Attendee Removed");
      })
      .catch((error) => {
        console.log("ERROR:");
        console.log(error);
      });
  };

  const handleClickAddAttendee = () => {
    setDialogStudentsOpen(true);
  };

  const handleStudentsClose = () => {
    setDialogStudentsOpen(false);
  };

  const handleStudentsOK = (selectedStudents) => {
    setDialogStudentsOpen(false);

    if (selectedStudents.length === 0) {
      return;
    }

    // collect IDs from raw values
    const studentEids = [];
    for (const student of selectedStudents) {
      studentEids.push(student.value);
    }

    setShowProgress(true);
    addStudentsToEvent(_school, _jwt, eventEid, studentEids)
      .then((results) => {
        if (hasError(results) === true) {
          showToast("E", "Unable to Add Students: ", getError(results));
          return;
        }

        initSignupMembers();
      })
      .catch((error) => {
        console.log("ERROR:");
        console.log(error);
      })
      .finally(() => {
        setShowProgress(false);
      });
  };
  return (
    <>
      <DrawerAppBar />

      <Container sx={{ mt: 1 }}>
        <Title text="Event Attendance" showBack={true} />
        <ProgressBar showProgress={_showProgress} />

        <BrowserView>
          <Alert severity="info" sx={{ mt: 1, mb: 1 }}>
            <span className="emphasis">INSTRUCTIONS</span> - Mark the Students
            who are in attendance, and click one the SAVE buttons below.
          </Alert>
        </BrowserView>

        {_event != null && (
          <Box sx={{ boxShadow: 1, p: 1, mt: 0 }}>
            <EventDetails school={_school} eventDetails={_event.event} />
          </Box>
        )}

        <Box sx={{ boxShadow: 1, p: 1, mt: 2 }}>
          <SubTitle text="Student List" sx={{ mt: 0 }} />

          <Button
            onClick={handleClickAddAttendee}
            sx={{ ml: 0 }}
            variant="contained"
          >
            Add Attendee
          </Button>
          <br />
          <br />

          <BrowserView>
            <Table>
              <Thead>
                <Tr>
                  <Th width={50}>
                    <div className="textCenter">Leaving Present?</div>
                  </Th>
                  <Th width={50}>
                    <div className="textCenter">Return Present?</div>
                  </Th>
                  <Th width={50}>
                    <div className="textCenter">Permission Slip?</div>
                  </Th>
                  <Th>Student Name</Th>
                  <Th width={100}>
                    <div className="textCenter">Actions</div>
                  </Th>
                </Tr>
              </Thead>
              <Tbody>
                {_members.map((student) => (
                  <>
                    <Tr key={student.eid}>
                      <Td>
                        <div className="textCenter">
                          <Checkbox
                            sx={{ pt: 0 }}
                            checked={student.leaveAttendStatus >= 100}
                            onChange={(event) =>
                              handleChangeLeaveAttendModify(event, student.eid)
                            }
                          />
                        </div>
                      </Td>

                      <Td>
                        <div className="textCenter">
                          <Checkbox
                            sx={{ pt: 0 }}
                            checked={student.returnAttendStatus === 100}
                            onChange={(event) =>
                              handleChangeReturnAttendModify(event, student.eid)
                            }
                          />
                        </div>
                      </Td>

                      <Td>
                        <div className="textCenter">
                          <Checkbox
                            sx={{ pt: 0 }}
                            checked={student.permissionSlipStatus === 100}
                            onChange={(event) =>
                              handleChangePermissionSlipModify(
                                event,
                                student.eid
                              )
                            }
                          />
                        </div>
                      </Td>

                      <Td>
                        <div className="emphasis">
                          {student.last_name}, {student.first_name} (
                          {student.grade})
                        </div>
                        {student.email}
                        <br />
                      </Td>

                      <Td>
                        <Button
                          variant="outlined"
                          onClick={() => removeAttendee(student)}
                        >
                          Remove
                        </Button>
                      </Td>
                    </Tr>
                  </>
                ))}
                {_members.length === 0 && (
                  <Tr>
                    <Td colSpan={6}>-- NO ATTENDEES --</Td>
                  </Tr>
                )}
              </Tbody>
            </Table>
          </BrowserView>

          <Button
            key="save2"
            onClick={handleClickSave}
            sx={{ ml: 0, mt: 2 }}
            color="success"
            variant="contained"
          >
            SAVE
          </Button>
        </Box>
      </Container>

      <SelectStudentsDialog
        open={_dialogStudentsOpen}
        onClose={handleStudentsClose}
        onOK={handleStudentsOK}
        students={_students}
      />
    </>
  );
};

export default EventTakeAttendance;
